import React from "react";

export default function OrderDisclosure({
  title,
  icon,
  count,
  variant = "history",
  open,
  children,
}) {
  return (
    <details
      open={open}
      aria-label={title}
      className={`premium-disclosure premium-disclosure-${variant}`}
    >
      <summary>
        <i className={`bi ${icon}`} aria-hidden="true" />
        <strong>{title}</strong>
        {count != null && (
          <span className="premium-disclosure-count">{count}</span>
        )}
        <i className="bi bi-chevron-down" aria-hidden="true" />
      </summary>
      <div className="premium-disclosure-body">{children}</div>
    </details>
  );
}
